import React from 'react'
import { LottieLoader } from '@mondra/ui-components'


export default function ButterflyLoader({ title = 'Loader', ...rest }: any) {
    return <LottieLoader lottieType="butterflyLottie" title={title} {...rest} />
}
